import { queryOptions } from "@tanstack/react-query";
import { z } from "zod";

import { restFetcher } from "~/api/fetchers";
import { createFilter } from "~/api/utils";

// Client Search
// -----------------------

const clientSearchResultSchema = z.object({
  id: z.number(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  preferredName: z.string().optional(),
  phone: z.string().optional(),
  email: z.string().optional(),
  address: z.string().optional(),
  clientId: z.string(),
  medicalServiceId: z.string().optional(),
  dateOfBirth: z.string().optional(),
  currentStatus: z.object({ active: z.boolean() }).optional(),
  securePatientId: z.number().optional(),
  accessLevel: z.string().optional(),
  active: z.boolean().optional(),
});

export type ClientSearchResultSchema = z.infer<typeof clientSearchResultSchema>;

const clientSearchResponse = z.object({
  page: z.number(),
  results: z.array(clientSearchResultSchema),
  pages: z.number(),
  count: z.number(),
  total: z.number(),
});

type ClientSearchResponse = z.infer<typeof clientSearchResponse>;

interface ClientSearchQueryParams {
  searchterm: string;
  page?: number;
  size?: number;
  activeonly?: boolean;
  searchAddresses?: boolean;
  sortattr?: string;
  sortdir?: string;
}

export const ClientSearchApi = {
  searchByTerm: (filter: ClientSearchQueryParams) => {
    const searchParams = createFilter<ClientSearchQueryParams>(filter);
    return queryOptions({
      queryKey: ["clientsearch", filter],
      queryFn: async ({ signal }) => {
        const resp = await restFetcher<ClientSearchResponse>(
          `/v1/clientsearch?${searchParams.toString()}`,
          { signal }
        );
        return clientSearchResponse.parse(resp);
      },
      staleTime: 60 * 1000, // Cache results for 60 seconds when re-searching,
      enabled: filter.searchterm.length > 0,
    });
  },
};
